import { FieldPropsConfig } from 'ui/forms/custom/types';

import { commonFieldsProps } from '../common/fields';

export const LTFieldProps: Record<string, FieldPropsConfig> = {
  ...commonFieldsProps,
  title: {
    fieldType: 'input',
    maxLength: 20,
    validations: ['addressTitle'],
  },
  email: {
    fieldType: 'input',
    validations: ['email'],
    maxLength: 50,
  },
  phone: {
    fieldType: 'input',
    validations: ['phoneNumber'],
    pattern:
      '^[\\+(/. 0-9 \\)-]+[ ]*((( |x|ext|ext.|extension|Ext|Ext.|Extension|#){1}[ ]?([0-9]){1,7}){0,1})$',
    maxLength: 30,
  },
  phoneNumber: {
    fieldType: 'input',
    pattern:
      '^[\\+(/. 0-9 \\)-]+[ ]*((( |x|ext|ext.|extension|Ext|Ext.|Extension|#){1}[ ]?([0-9]){1,7}){0,1})$',
  },
  password: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  newPassword: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  currentPassword: {
    fieldType: 'password',
    maxLength: 255,
  },
  passwordConfirmation: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  newPasswordConfirmation: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  newResetPassword: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  newResetPasswordConfirmation: {
    fieldType: 'password',
    validations: ['password'],
    maxLength: 255,
  },
  cancelLink: {
    fieldType: 'link',
    href: '/account',
  },
  countryCode: {
    fieldType: 'dropdown',
    validations: [],
    options: [{ label: 'Lithuania', value: 'LT' }],
  },
  streetNumber: {
    fieldType: 'input',
    maxLength: 10,
    validations: ['latinLettersOnly'],
  },
  postalCode: {
    fieldType: 'input',
    autoCapitalize: 'characters',
    maxLength: 10,
    pattern: '\\d{5}',
    validations: ['postalCode'],
  },
  billingPostalCode: {
    fieldType: 'input',
    autoCapitalize: 'characters',
    minLength: 5,
    maxLength: 10,
    pattern: '\\d{5}',
  },
  firstName: {
    fieldType: 'input',
    validations: ['latinLettersOnly', 'name'],
    maxLength: 30,
  },
  lastName: {
    fieldType: 'input',
    validations: ['latinLettersOnly', 'name'],
    maxLength: 30,
  },
  companyName: {
    fieldType: 'input',
    validations: ['latinLettersOnly'],
    maxLength: 50,
  },
  address1: {
    fieldType: 'input',
    validations: ['latinLettersOnly'],
    maxLength: 50,
  },
  address2: {
    fieldType: 'input',
    validations: ['latinLettersOnly'],
    maxLength: 50,
  },
  city: {
    fieldType: 'input',
    validations: ['latinLettersOnly'],
    maxLength: 50,
    minLength: 2,
  },
};
